import { render, staticRenderFns } from "./SpedilinkInterestsPanel.vue?vue&type=template&id=60978dc6&scoped=true&"
import script from "./SpedilinkInterestsPanel.vue?vue&type=script&lang=js&"
export * from "./SpedilinkInterestsPanel.vue?vue&type=script&lang=js&"
import style0 from "./SpedilinkInterestsPanel.vue?vue&type=style&index=0&id=60978dc6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60978dc6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VChip,VIcon,VSimpleTable})
